import React from 'react';
import {Link} from 'react-router-dom';
// import LazyLoad from 'react-lazyload';
import {Image} from './Image';

const Page = (props) => (
  <li className="book-book" id={props.id}>
    {/* <div className="book-book__marker hidden"></div> */}
    <Link to={{ pathname: "/Pages/" + props.id }} >
      <Image type={props.type} class={props.class} id={props.id} img={props.img}></Image>
      {/* <LazyLoad height={200} offset={200}>
        <Image type={props.type} class={props.class} id={props.id} img={props.img}></Image>
      </LazyLoad> */}
      <div className="page-name">page id: <span className="page-name__name">{props.id}</span></div>
    </Link>
  </li>
)

export default Page



// WEBPACK FOOTER //
// ./src/components/Page.js